import vuetify from "@/main";
import TrustDepositModal from '@/components/modals/TrustDepositModal.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('billing.payment', {
    url: "/payment",
    template: "<div ui-view></div>"
  }).state('billing.payment.summary', {
    url: "/summary",
    views: {
      '': {
        controller: 'PaymentSummaryCtrl',
        template: require('./views/summary.html')
      }
    }
  }).state('billing.payment.matter', {
    url: "/matter/{clientId}/{matterId}",
    template: require('./views/payment.matter.html'),
    controller: 'PaymentMatterCtrl'
  }).state('billing.payment.matter.trust', {
    url: "/trust",
    views: {
      'edit': {
        template: require('../../accounting/views/trust.matter.html'),
        controller: 'TrustMatterCtrl'
      }
    }
  }).state('billing.payment.matter.deposit', {
    url: "/deposit",
    views: {
      'edit': {
        ...vuetify(TrustDepositModal)
      }
    }
  });
}]);